<template>
  <div>
    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
      v-autofocus="!form.id"
    ></form-field-input>

    <form-field-select
      v-if="!form.id"
      label="Type"
      v-model="form.data_type"
      :validation-errors="validationErrors.data_type"
    >
      <option
        v-for="dataType in ENUMS.WebhookDataTypeEnum"
        :key="dataType.value"
        :value="dataType.value"
      >{{ dataType.label }}</option>
    </form-field-select>

    <template v-if="form.data_type === ENUMS.WebhookDataTypeEnum.Contact.value">
      <form-field-collection
        v-model="form.contact_tags"
        :options="$store.getters.contactTags"
        label="Attach Tags"
        help-text="Note: Tags must be created via Contact Settings before attaching to a contact"
        field="label"
        placeholder="Select tag"
        icon="label"
        :validation-errors="validationErrors.contact_tags"
      ></form-field-collection>

      <form-field-select-contact-types
        v-model="form.contact_types"
        :validation-errors="validationErrors.contact_types"
      />
    </template>
    <template v-else>
      <form-field-select-campaign
        label="Default Campaign"
        v-model="form.campaign_id"
        :validation-errors="validationErrors.campaign_id"
        help-text="Campaign to assign to the new Leads created by this Webhook"
      ></form-field-select-campaign>

      <form-field-select-users
        label="Default User"
        v-model="form.user_id"
        :validation-errors="validationErrors.user_id"
        help-text="User to assign new Leads created by this Webhook"
      ></form-field-select-users>

      <form-field-select-status
        label="Default Status"
        v-model="form.status_id"
        :validation-errors="validationErrors.status_id"
        :required="true"
        help-text="Status to place new Leads created by this Webhook"
      ></form-field-select-status>

      <form-field-select-temperature
        label="Default Temperature"
        v-model="form.temperature"
        :validation-errors="validationErrors.temperature"
        help-text="Temperature to set for new Leads created by this Webhook"
      ></form-field-select-temperature>
    </template>

    <template v-if="form.id">
      <div class="mb-100">
        <form-field-instructions
          heading="Multi-Step Form"
          text="For forms that get submitted in two parts, turn on multi-step and input the name (i.e. submission_id or email_address) of a unifier field that is present on both forms and press Save."
        ></form-field-instructions>

        <form-field-switch
          label="Multi Step Form"
          v-model="form.is_multi_step_form"
          :validation-errors="validationErrors.is_multi_step_form"
        ></form-field-switch>

        <form-field-input
          v-if="form.is_multi_step_form"
          label="Unifier Field"
          v-model="form.unifier_id"
          :validation-errors="validationErrors.unifier_id"
        ></form-field-input>
      </div>

      <div class="mb-100">
        <form-field-instructions
          heading="Activate Webhook"
          :text="`To start creating ${formLabel} click on activate. You may always disable this as needed.`"
        ></form-field-instructions>

        <form-field-switch
          label="Activate"
          v-model="form.is_active"
          :validation-errors="validationErrors.is_active"
        ></form-field-switch>
      </div>
    </template>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import FormFieldSelectCampaign from "../components/form/FormFieldSelectCampaign";
import {ENUMS} from "../services/enums";

export default {
  name: "WebhookForm",
  components: {FormFieldSelectCampaign},
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      isSaving: false,
      defaultForm: {
        market_id: this.$store.getters.market.id,
        label: '',
        data_type: ENUMS.WebhookDataTypeEnum.Lead.value,
        contact_types: [],
        contact_tags: [],
        // token: '',
        // field_maps: '',
        unifier_id: null,
        is_multi_step_form: false,
        is_active: false,
        campaign_id: null,
        user_id: null,
        status_id: this.$store.getters["pipeline/statuses"].first().id,
        temperature: ENUMS.TemperatureEnum.None.value,
      },
    }
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone({...this.defaultForm, ...this.formData}) : this.$utils.clone(this.defaultForm);
  },
  computed: {
    formLabel() {
      return (this.form.data_type === ENUMS.WebhookDataTypeEnum.Lead.value) ? 'leads' : 'contacts'
    },
  },
  methods: {
    create() {
      return this.$api.webhooks.create(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Webhook was created',
            type: 'is-success'
          });

          return res;
        });
    },
    update() {
      return this.$api.webhooks.update(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Webhook was updated',
            type: 'is-success'
          });

          return res;
        });
    },
    delete() {
      return this.$api.webhooks.delete(this.form.id)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Webhook was archived',
            type: 'is-success'
          });

          return res;
        });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
